module.exports = __webpack_public_path__ + "img/Support-skill-228.3b292ced.png";